<template>
  <section
    class="ds-chart-box"
    :class="{ 'ds-chart-box--fullwidth': fullwidth }"
  >
    <div
      v-if="showHeading"
      class="ds-chart-box__heading"
    >
      <div class="ds-chart-box__main">
        <slot name="title" />
        <slot name="description" />
        <h1
          v-if="!showTitleSlot && showTitle"
          class="ds-chart-box__title"
        >
          {{ title }}
        </h1>
        <p
          v-if="!showDescriptionSlot && showDescription"
          class="ds-chart-box__description"
        >
          {{ description }}
        </p>
      </div>

      <div
        v-if="showPrimaryActionSlot"
        class="ds-chart-box__primary-action"
      >
        <slot name="primary-action" />
      </div>
    </div>

    <div
      v-if="showSecondaryActionSlot"
      class="ds-chart-box__secondary-action"
    >
      <slot name="secondary-action" />
    </div>

    <slot />
  </section>
</template>

<script>
export default {
  name: 'ChartBox',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullwidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showTitle() {
      return this.title !== '';
    },
    showDescription() {
      return this.description !== '';
    },
    showTitleSlot() {
      return Array.isArray(this.$slots.title);
    },
    showDescriptionSlot() {
      return Array.isArray(this.$slots.description);
    },
    showPrimaryActionSlot() {
      return Array.isArray(this.$slots['primary-action']);
    },
    showSecondaryActionSlot() {
      return Array.isArray(this.$slots['secondary-action']);
    },
    showHeading() {
      return [
        this.showTitle,
        this.showDescription,
        this.showTitleSlot,
        this.showDescriptionSlot,
      ].some(v => v === true);
    },
  },
  mounted() {
    document.documentElement.setAttribute(
      'data-color-theme',
      this.dark ? 'dark' : ''
    );
  },
};
</script>

<style lang="scss" scoped>
.ds-chart-box {
  position: relative;
  border: 1px solid var(--ds-color-silver);
  background-color: var(--ds-color-neutral);
  border-radius: var(--ds-border-radius-md);
  font-family: var(--ds-font-family);
  min-height: 172px;
  min-width: 356px;
  padding: var(--ds-spacing-inset-xs);

  &--fullwidth {
    padding: 0;
    border: none;
  }

  &__heading {
    display: grid;
    grid-template-columns: auto auto;
    gap: var(--ds-spacing-stack-xs);
    margin-bottom: var(--ds-spacing-stack-md);

    h1 {
      font-size: var(--ds-font-size-md);
      font-weight: var(--ds-font-weight-semibold);
      margin: 0;
      margin-bottom: var(--ds-spacing-stack-nano);
      color: var(--ds-color-text-1);
    }

    p {
      color: var(--ds-color-text-2);
      font-size: var(--ds-font-size-sm);
      margin: 0;
    }
  }

  &__main {
    display: flex;
    flex-direction: column;
  }

  &__primary-action,
  &__secondary-action {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  &__secondary-action {
    justify-content: space-between;
    margin-bottom: var(--ds-spacing-stack-nano);
  }

  &__title {
    font-size: var(--ds-font-size-md);
    font-weight: var(--ds-font-weight-semibold);
    margin: 0;
    margin-bottom: var(--ds-spacing-stack-nano);
    color: var(--ds-color-text-1);
  }

  &__description {
    color: var(--ds-color-text-2);
    font-size: var(--ds-font-size-sm);
    margin: 0;
  }
}
</style>
